import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaBaseResponse } from '../../responses/repositorio-tintas/lista-base.response';

@Injectable({
  providedIn: 'root',
})
export class BaseService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  public listaBase(idFabricante: number, paginaAtual: number): Observable<ListaBaseResponse> {
    const uri: string = `base/listaBase/idFabricante/${idFabricante}?paginaAtual=${paginaAtual}`;

    return this.httpClient
      .get<ListaBaseResponse>(environment.urlApiRepositorioTintas + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
